/**
 * Created by robert.lavoie on 6/20/17.
 */

import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';

// Models
import { Filter } from '../../models';

// Services
import { SiteService } from '../../services';

/**
 *
 * @class
 * JobsSearchResultsListViewComponent
 *
 * @description
 * This component displays a list of jobs based on your search
 * There are two view types map and list
 *
 */
@Component({
  templateUrl: './jobs-search-results-list-view.component.html',
  selector: 'jobs-search-results-list-view',
  styleUrls: ['./jobs-search-results-list-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JobsSearchResultsListViewComponent implements OnInit {

  // Array array of job results from your search
  @Input() jobResults: object[];

  // The configuration object for pagination
  @Input() config: object;

  // The sites theme color
  @Input() themeColor: string;

  // The location you searched for
  @Input() currentLocation: string;

  // If we should show the distance column to the user
  @Input() showDistance: boolean;

  // Is set to true after a list search has completed
  @Input() hasSearched: boolean;

  // This is used to determine if we need to show job type headline
  @Input() jobTypeFilter: Filter;

  // used to toggle the apply btn on the job listing
  public showApply = true;

  // used to toggle the share btn on the job listing
  public showShare = true;

  constructor(
    private router: Router,
    private siteService: SiteService
  ) {}

  ngOnInit() {}

  /**
   * Builds the category string for a single job, used on search results
   * @param job {any} - single row of the results we get back from the API search
   * @returns {string} - comma separated list of categories for a specific job
   */
  buildCategoryString(job: any): string {
    if (job.Categories) {
      return job.Categories.map(x => x).join(', ');
    }
  }
}
